// Acceleration units with conversion factors to meters per second squared (m/s²)
export const accelerationUnits = [
  { id: 'meter-per-second-squared', name: 'Meter/Second²', symbol: 'm/s²', plural: 'Meters/Second²', factor: 1 },
  { id: 'decimeter-per-second-squared', name: 'Decimeter/Second²', symbol: 'dm/s²', plural: 'Decimeters/Second²', factor: 0.1 },
  { id: 'kilometer-per-second-squared', name: 'Kilometer/Second²', symbol: 'km/s²', plural: 'Kilometers/Second²', factor: 1000 },
  { id: 'hectometer-per-second-squared', name: 'Hectometer/Second²', symbol: 'hm/s²', plural: 'Hectometers/Second²', factor: 100 },
  { id: 'dekameter-per-second-squared', name: 'Dekameter/Second²', symbol: 'dam/s²', plural: 'Dekameters/Second²', factor: 10 },
  { id: 'centimeter-per-second-squared', name: 'Centimeter/Second²', symbol: 'cm/s²', plural: 'Centimeters/Second²', factor: 0.01 },
  { id: 'millimeter-per-second-squared', name: 'Millimeter/Second²', symbol: 'mm/s²', plural: 'Millimeters/Second²', factor: 0.001 },
  { id: 'micrometer-per-second-squared', name: 'Micrometer/Second²', symbol: 'µm/s²', plural: 'Micrometers/Second²', factor: 0.000001 },
  { id: 'nanometer-per-second-squared', name: 'Nanometer/Second²', symbol: 'nm/s²', plural: 'Nanometers/Second²', factor: 0.000000001 },
  { id: 'gal', name: 'Gal', symbol: 'Gal', plural: 'Gals', factor: 0.01 },
  { id: 'galileo', name: 'Galileo', symbol: 'Gal', plural: 'Galileos', factor: 0.01 },
  { id: 'mile-per-second-squared', name: 'Mile/Second²', symbol: 'mi/s²', plural: 'Miles/Second²', factor: 1609.344 },
  { id: 'yard-per-second-squared', name: 'Yard/Second²', symbol: 'yd/s²', plural: 'Yards/Second²', factor: 0.9144 },
  { id: 'foot-per-second-squared', name: 'Foot/Second²', symbol: 'ft/s²', plural: 'Feet/Second²', factor: 0.3048 },
  { id: 'inch-per-second-squared', name: 'Inch/Second²', symbol: 'in/s²', plural: 'Inches/Second²', factor: 0.0254 },
  { id: 'standard-gravity', name: 'Standard Gravity', symbol: 'g', plural: 'Standard Gravities', factor: 9.80665 },
  { id: 'free-fall', name: 'Acceleration of Free Fall', symbol: 'g₀', plural: 'Free Falls', factor: 9.80665 },
];

export const popularAccelerationConversions = [
  { from: 'meter-per-second-squared', to: 'foot-per-second-squared' },
  { from: 'foot-per-second-squared', to: 'meter-per-second-squared' },
  { from: 'meter-per-second-squared', to: 'standard-gravity' },
  { from: 'standard-gravity', to: 'meter-per-second-squared' },
  { from: 'gal', to: 'meter-per-second-squared' },
  { from: 'meter-per-second-squared', to: 'gal' },
  { from: 'centimeter-per-second-squared', to: 'meter-per-second-squared' },
  { from: 'kilometer-per-second-squared', to: 'meter-per-second-squared' },
  { from: 'mile-per-second-squared', to: 'meter-per-second-squared' },
  { from: 'inch-per-second-squared', to: 'centimeter-per-second-squared' },
];

export const getUnitById = (id) => accelerationUnits.find(unit => unit.id === id);

export const convertAcceleration = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert ${fromUnit.plural.toLowerCase()} (${fromUnit.symbol}) to ${toUnit.plural.toLowerCase()} (${toUnit.symbol}) and learn the conversion formula.`;
};
